import React from 'react';

export default function ButtonSecondary({className, text, disabled, ...other}) {
	return <button className={` button button--secondary ${className ? className : ''}`} disabled={disabled} {...other}>
		{text}
	</button>
}
